var symphony = symphony || {};

;
(function () {

	symphony.alertsDisplay = function () {

		if (!_.isUndefined(symphony) && !_.isUndefined(symphony.admin) && !_.isUndefined(symphony.admin.activeConductorDocs)) {
			var activeProperties = [];
			var today = moment().utc()._d;

			activeProperties = {
				objects: symphony.admin.activeConductorDocs
			}

			var index = _.findIndex(activeProperties.objects, function (property) {
				return property.name === "alerts"
			});

			if (activeProperties.objects[index] && activeProperties.objects[index] != null) {
				var propertyObject = JSON.parse(activeProperties.objects[index].value);

				activeProperties.objects[index].value = propertyObject;
				$('body').append('<div class="alerts"></div>');

				for (var i = 0; i < activeProperties.objects[index].value.objects.length; i++) {
					var prop = activeProperties.objects[index].value.objects[i];

					if (prop.activeSites != null && prop.activeSites.indexOf(siteId + "-" + prop.id) !== -1) {
						if (moment(moment(prop.endDate, "MM-DD-YYYY").utc()._d).isAfter(today) && moment(moment(prop.startDate, "MM-DD-YYYY").utc()._d).isBefore(today)) {

							if (!(localStorage.getItem(siteId + "-" + prop.id) == prop.title)) {
								localStorage.setItem(siteId + "-" + prop.id, prop.title);
								$('.alerts').append('<div class="alert ' + symphony.alertsColorTranslate(prop.bgColor) + '">' + prop.message + '</div>');
							}
						}
					}
				}

				$('.adminNotification-close').on('click', function () {
					var name = _.camelCase($(this).parent().data('title'));
					$(this).parent().remove();
					localStorage.setItem(name, 'closed');
				});
			}
		} else {

			symphony.alertsAdjustMenuHeight();

			var data = {
				conductorData: {},
				siteData: {}
			}

			$.when(
				$.get('/' + conductorUrlAlias + '/json/properties', function (conductorData) {
					data.conductorData = conductorData;
				}),
				$.get('/' + siteUrlAlias + '/json/properties', function (siteData) {
					data.siteData = siteData;
				}),
			).then(function () {
				var activeProperties = {};
				var conductorActiveProperties = [];
				var siteActiveProperties = [];
				var today = moment().utc()._d;
				var today_bod = moment(today).startOf("day");

				conductorActiveProperties = typeof data.conductorData == "string" ? JSON.parse(data.conductorData) : data.conductorData;
				siteActiveProperties = typeof data.siteData == "string" ? JSON.parse(data.siteData) : data.siteData;

				symphony.config.properties = JSON.parse(JSON.stringify(siteActiveProperties)).objects;
				symphony.config.conductorProperties = JSON.parse(JSON.stringify(conductorActiveProperties)).objects;

				var index = _.findIndex(conductorActiveProperties.objects, function (property) {
					return property.name === "alerts"
				});
				var sIndex = _.findIndex(siteActiveProperties.objects, function (property) {
					return property.name === "alerts"
				});

				if (conductorActiveProperties.objects[index] && conductorActiveProperties.objects[index].value) {
					conductorActiveProperties = JSON.parse(conductorActiveProperties.objects[index].value);
					siteActiveProperties = sIndex == -1 ? {
						objects = []
					} : JSON.parse(siteActiveProperties.objects[sIndex].value);
				}


				for (var i = 0; i < siteActiveProperties.objects.length; i++) {
					var site = siteActiveProperties.objects[i];
					site.activeSites = [siteId];
				}

				activeProperties = conductorActiveProperties.objects.concat(siteActiveProperties.objects); // Merge alerts from both conductor and Local Admin
				if (activeProperties) {
					$('body').append('<div class="alerts"></div>');

					for (var j = 0; j < activeProperties.length; j++) {
						var prop = activeProperties[j];

						if (prop.activeSites != null && prop.activeSites.indexOf(siteId) !== -1) {
							if (moment(moment(prop.endDate, "MM-DD-YYYY").utc()._d).isAfter(today) && moment(moment(prop.startDate, "MM-DD-YYYY").utc()._d).isBefore(today)) {
								if (!(localStorage.getItem(siteId + "-" + prop.id) && moment(localStorage.getItem(siteId + "-" + prop.id)).isSame(today_bod))) {
									localStorage.setItem(siteId + "-" + prop.id, today_bod);
									$('.alerts').append('<div class="alert ' + symphony.alertsColorTranslate(prop.bgColor) + '">\
										' + prop.message + ' \
										<i class="close fas fa-times"></i>\
									</div>');
								}
							}
						}
					}

					symphony.alertsAdjustMenuHeight();


					$('.close').on('click', function () {
						$(this).parent().remove();
						setTimeout(function () {
							symphony.alertsAdjustMenuHeight();
						}, 100);
					});

					$('.adminNotification-close').on('click', function () {
						var name = _.camelCase($(this).parent().data('title'));
						$(this).parent().remove();
						localStorage.setItem(name, 'closed');
					});

					// add resize event
					if (UTIL) {
						var returnedFunction = UTIL.debounce(function () {
							symphony.alertsAdjustMenuHeight();
						}, 250);

						window.addEventListener('resize', returnedFunction);
					} else {
						$(window).resize(function () {
							symphony.alertsAdjustMenuHeight();
						});
					}
				}
			});
		}
	};

	symphony.alertsAdjustMenuHeight = function () {
		if ($('.alerts').length > 0) {
			var alertsHeight = $('.alerts').outerHeight();
			if (alertsHeight > 0) {
				if (document.body.classList.contains('kroc-theme')) {
					$('body').css({
						'padding-top': $('.globalHeader').outerHeight() + alertsHeight + 'px'
					});
				} else {
					var headerHeight = 66;
					var givingToolbarHeight = 0;
					if ($('body').hasClass('hasGivingToolbar')) {
						givingToolbarHeight += 48;
					}
					$('body').css({
						'padding-top': headerHeight + givingToolbarHeight + alertsHeight + 'px'
					});

					$('body').addClass('header-isSticky');
					$('body').addClass('givingToolbar-isSticky');
					$('body').addClass('always-isSticky');
				}
				$('.globalHeader').attr('style', 'top: ' + alertsHeight + 'px !important');
				$('.givingToolbar-toolbar').attr('style', 'top: ' + (alertsHeight + 66) + 'px !important');
			} else {
				revert();
			}
		} else {
			revert();
		}

		function revert() {
			if (document.body.classList.contains('kroc-theme')) {
				$('body').css({
					'padding-top': $('.globalHeader').outerHeight() + 'px'
				});
			} else {
				$('body').attr('style', '');
			}
			$('.globalHeader').attr('style', '');
			$('.givingToolbar-toolbar').attr('style', '');
		}
	}

	symphony.alertsColorTranslate = function (hex) {
		var className = "red";
		switch (hex) {
			case '#22b573':
				className = 'alertGreen';
				break;
			case '#2a313f':
				className = 'alertBlue';
				break;
			case '#edb95d':
				className = 'alertYellow';
				break;
			case '#ed1c2b':
				className = 'alertRed';
				break;
		}

		return className;
	}
})();
